// extracted by mini-css-extract-plugin
export default {"loading":"style_loading__ApOBK","spinner":"style_spinner__9jo+X"};